import { ReactNode } from "react";
import { cx } from "../react-helpers/css";
import { TableSort } from "../react-helpers/array";

interface Props<K extends string> {
  /** Identifies this column among the comparators given to `useTableSort`. */
  sortKey: K;
  sort: TableSort<K> | null;
  onSort: (key: K) => void;
  children: ReactNode;
}

function SortableTh<K extends string>({
  sortKey,
  sort,
  onSort,
  children,
}: Props<K>) {
  const isActive = sort?.key === sortKey;

  return (
    <th
      aria-sort={
        isActive
          ? sort.direction === "asc"
            ? "ascending"
            : "descending"
          : "none"
      }
    >
      <button
        type="button"
        className={cx([
          "table_sort",
          isActive && "--active",
          isActive && sort.direction === "desc" && "--desc",
        ])}
        onClick={() => onSort(sortKey)}
      >
        {children}
      </button>
    </th>
  );
}

export default SortableTh;
